"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.allColonyNames = allColonyNames;
exports.getColony = getColony;
const coloniesJson = require("@/genfiles/colonies.json");
const colonies = new Map();
coloniesJson.forEach((colony) => {
    colonies.set(colony.name, colony);
});
function allColonyNames() {
    return colonies.keys();
}
function getColony(name) {
    const metadata = colonies.get(name);
    if (metadata === undefined) {
        throw new Error(`Unknown colony ${name}`);
    }
    return metadata;
}
